// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLICK_HERE = "klikni sem";
export const SESSION_TIME_OUT_TO_RELOAD_link = "Platnos\u0165 rel\u00e1cie vypr\u0161ala, pre obnovenie %(link)s.";
